import React, { useState, useEffect, useContext } from "react";
import "../../../styles/OceanicBliss.css";
import { UserContext } from '../../UserContext';
import { useNavigate,useLocation, Navigate } from "react-router-dom";


const OceanicBliss = (props) => {


  return (
    <div>
      <div id="website_3">
	<svg class="right_top_blue_design_website_">
		<rect id="right_top_blue_design_website_" rx="0" ry="0" x="0" y="0" width="511" height="841">
		</rect>
	</svg>
	<div id="Lines_top_website_3">
		<svg class="bg_3_website_3">
			<rect id="bg_3_website_3" rx="0" ry="0" x="0" y="0" width="1" height="841">
			</rect>
		</svg>
		<svg class="bg_2_website_3">
			<rect id="bg_2_website_3" rx="0" ry="0" x="0" y="0" width="1" height="224">
			</rect>
		</svg>
		<svg class="bg_1_website_3">
			<rect id="bg_1_website_3" rx="0" ry="0" x="0" y="0" width="1" height="426">
			</rect>
		</svg>
	</div>
	<div id="Scroll_comp_intro_web_3">
		<div id="intro_lbl_website_3_ob_pc">
			<span>{props.data.introduction}</span>
		</div>
	</div>
	<div id="Heading_website_3">
		<span>{props.data.businessName && props.data.businessName.length > 0?props.data.businessName:props.data.name}</span>
	</div>
	<div id="Small_Heading_top_website_3">
		<span>{props.data.city} , {props.data.country}</span>
	</div>


	<div id="we_stand_for_grp">
		<div id="Card_03_website_3">
			<div id="Scroll_Group_principle_">
				<div id="intro_lbl_website_3_b">
					<span>{props.data.principles}</span>
				</div>
			</div>
			<div id="principles_lbl_website_3">
				<span>Principles</span>
			</div>
			<svg class="Fill_pink_website_3">
				<rect id="Fill_pink_website_3" rx="20" ry="20" x="0" y="0" width="90" height="90">
				</rect>
			</svg>
			<svg class="Icon_left_website_3" viewBox="0 4.994 16.479 20.006">
				<path id="Icon_left_website_3" d="M 16.4786205291748 4.993944644927979 L 0 4.993944644927979 L 0 25 L 3.838300466537476 25 L 3.838300466537476 23.81310653686523 C 3.838300466537476 22.32072830200195 5.008660793304443 21.10429763793945 6.425898551940918 21.10429763793945 L 10.052414894104 21.10429763793945 C 11.4714994430542 21.10429763793945 12.64986228942871 22.32072830200195 12.64986228942871 23.81310653686523 L 12.64986228942871 25 L 16.4786205291748 25 L 16.4786205291748 4.993944644927979 Z">
				</path>
			</svg>
			<svg class="Icon_top_website_3" viewBox="1.03 0 18.923 3.37">
				<path id="Icon_top_website_3" d="M 4.081475257873535 0 L 1.029673933982849 3.369782447814941 L 16.89017677307129 3.369782447814941 L 19.95275115966797 0 L 4.081475257873535 0 Z">
				</path>
			</svg>
			<svg class="Icon_right_website_3" viewBox="18.017 1.194 2.983 22.591">
				<path id="Icon_right_website_3" d="M 21 20.49074363708496 L 21 1.193708777427673 L 18.01715087890625 4.475838184356689 L 18.01715087890625 23.78456115722656 L 21 20.49074363708496 Z">
				</path>
			</svg>
		</div>
		<div id="Card_02_website_3">
			<div id="Scroll_Group_11">
				<div id="intro_2_website_3">
					<span>{props.data.mission}</span>
				</div>
			</div>
			<div id="mission_lbl_website_3">
				<span>Mission</span>
			</div>
			<div id="Icon_2_grp_websiote_3">
				<svg class="bg_blue_design">
					<rect id="bg_blue_design" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Icon_hand_website_3" viewBox="0 12.676 25 12.324">
					<path id="Icon_hand_website_3" d="M 5.418835639953613 25 L 0 19.75765228271484 L 3.882342338562012 15.93112277984619 C 4.668581485748291 15.1504545211792 5.66070556640625 14.60586261749268 6.74470853805542 14.35992527008057 C 7.82871150970459 14.11398887634277 8.96060848236084 14.1766881942749 10.01033020019531 14.54081630706787 L 10.86336612701416 14.83673477172852 L 16.09720611572266 14.83673477172852 C 16.31855773925781 14.83662796020508 16.53767395019531 14.88068580627441 16.74154090881348 14.9662914276123 C 16.94540977478027 15.05189609527588 17.12987327575684 15.1773042678833 17.28397750854492 15.3350658416748 C 17.43808174133301 15.49282741546631 17.55868530273438 15.67972660064697 17.63862419128418 15.88466453552246 C 17.71856117248535 16.08960151672363 17.75620651245117 16.30839920043945 17.74932098388672 16.52806091308594 C 17.72418975830078 16.96226119995117 17.53105545043945 17.37002754211426 17.21026229858398 17.66618537902832 C 16.88946914672852 17.96234321594238 16.46582794189453 18.12398338317871 16.02783203125 18.11734580993652 L 12.88804149627686 18.11734580993652 C 12.71768093109131 18.11734580993652 12.55429744720459 18.18453979492188 12.43383407592773 18.30414199829102 C 12.31337070465088 18.42374420166016 12.24569511413574 18.58595848083496 12.24569511413574 18.75510025024414 C 12.24569511413574 18.92424392700195 12.31337070465088 19.08646011352539 12.43383407592773 19.20606231689453 C 12.55429744720459 19.32566452026367 12.71768093109131 19.39285659790039 12.88804149627686 19.39285659790039 L 16.03810882568359 19.39285659790039 C 16.80649948120117 19.39659118652344 17.54690742492676 19.10680389404297 18.10603332519531 18.5834903717041 C 18.6651611328125 18.06017684936523 19.00017738342285 17.34342193603516 19.04172134399414 16.58163261413574 C 19.04172134399414 16.56887817382812 19.04172134399414 16.55612182617188 19.04172134399414 16.54081535339355 L 21.95540618896484 13.28316307067871 C 22.25136184692383 12.94216728210449 22.66827583312988 12.72750949859619 23.1195068359375 12.68380165100098 C 23.57073783874512 12.64009380340576 24.02158164978027 12.77069759368896 24.37833786010742 13.04846954345703 C 24.55488014221191 13.19361686706543 24.70034980773926 13.37240314483643 24.80616569519043 13.5742769241333 C 24.91197967529297 13.77615165710449 24.97599601745605 13.9970235824585 24.99443626403809 14.22386169433594 C 25.01287651062012 14.45069980621338 24.98536682128906 14.67890644073486 24.91353225708008 14.89501667022705 C 24.84169578552246 15.11112689971924 24.72698974609375 15.31076240539551 24.57617950439453 15.48214244842529 L 18.75909042358398 22.11479568481445 C 18.37513542175293 22.55172348022461 17.90117835998535 22.90172386169434 17.36925888061523 23.14113616943359 C 16.83733940124512 23.38055038452148 16.25985145568848 23.50379753112793 15.67582607269287 23.50255012512207 L 6.937343120574951 23.49234580993652 L 5.418835639953613 25 Z">
					</path>
				</svg>
				<svg class="Icon_3_website_3" viewBox="10.417 4.918 8.532 8.305">
					<path id="Icon_3_website_3" d="M 18.59176063537598 8.214603424072266 C 18.36287879943848 7.987359046936035 18.05245018005371 7.85969352722168 17.7287654876709 7.85969352722168 L 15.93019485473633 7.85969352722168 L 15.93019485473633 6.073979377746582 C 15.91579151153564 5.762558460235596 15.7810525894165 5.468630313873291 15.55399036407471 5.253305912017822 C 15.32692813873291 5.037981033325195 15.02501487731934 4.917828559875488 14.71102142333984 4.917828559875488 C 14.39702796936035 4.917828559875488 14.09511470794678 5.037981033325195 13.86805248260498 5.253305912017822 C 13.64099025726318 5.468630313873291 13.50625133514404 5.762558460235596 13.49184799194336 6.073979377746582 L 13.49184799194336 7.85969352722168 L 11.69327735900879 7.85969352722168 C 11.52846431732178 7.852179527282715 11.3638277053833 7.877921581268311 11.20931816101074 7.935363292694092 C 11.05480861663818 7.992805480957031 10.91363334655762 8.080754280090332 10.79432487487793 8.19389533996582 C 10.67501544952393 8.307037353515625 10.58005142211914 8.443021774291992 10.51516914367676 8.593629837036133 C 10.45028686523438 8.74423885345459 10.41683483123779 8.906346321105957 10.41683483123779 9.07015323638916 C 10.41683483123779 9.233960151672363 10.45028686523438 9.396066665649414 10.51516914367676 9.546675682067871 C 10.58005142211914 9.697284698486328 10.67501544952393 9.833269119262695 10.79432487487793 9.946410179138184 C 10.91363334655762 10.05955219268799 11.05480861663818 10.14750099182129 11.20931816101074 10.20494270324707 C 11.3638277053833 10.26238441467285 11.52846431732178 10.28812599182129 11.69327735900879 10.28061199188232 L 13.49184799194336 10.28061199188232 L 13.49184799194336 12.06632614135742 C 13.50625133514404 12.37774753570557 13.64099025726318 12.67167568206787 13.86805248260498 12.88700008392334 C 14.09511470794678 13.10232448577881 14.39702796936035 13.22247695922852 14.71102142333984 13.22247695922852 C 15.02501487731934 13.22247695922852 15.32692813873291 13.10232448577881 15.55399036407471 12.88700008392334 C 15.7810525894165 12.67167568206787 15.91579151153564 12.37774753570557 15.93019485473633 12.06632614135742 L 15.93019485473633 10.28061199188232 L 17.7287654876709 10.28061199188232 C 18.05200576782227 10.28061294555664 18.36204528808594 10.15329933166504 18.59085273742676 9.926606178283691 C 18.81965827941895 9.699913024902344 18.94854354858398 9.392358779907227 18.9492244720459 9.071429252624512 L 18.9492244720459 9.071429252624512 C 18.9492244720459 8.750057220458984 18.82064056396484 8.441847801208496 18.59176063537598 8.214603424072266 Z">
					</path>
				</svg>
				<svg class="Icon_plus_2_website_3" viewBox="5.026 1.464 6.241 6.204">
					<path id="Icon_plus_2_website_3" d="M 7.248238563537598 3.673469305038452 L 5.925004482269287 3.673469305038452 C 5.68649959564209 3.673469305038452 5.457762241363525 3.76753830909729 5.289113998413086 3.934981346130371 C 5.120465278625488 4.102424621582031 5.02571964263916 4.329525947570801 5.02571964263916 4.56632661819458 C 5.02571964263916 4.803126811981201 5.120465278625488 5.030228614807129 5.289113998413086 5.197671890258789 C 5.457762241363525 5.365115165710449 5.68649959564209 5.459183692932129 5.925004482269287 5.459183692932129 L 7.250807762145996 5.459183692932129 L 7.250807762145996 6.775509834289551 C 7.250807762145996 7.01231050491333 7.345553874969482 7.239412307739258 7.51420259475708 7.406855583190918 C 7.682851314544678 7.574298858642578 7.911587715148926 7.668367385864258 8.150093078613281 7.668367385864258 C 8.388598442077637 7.668367385864258 8.617335319519043 7.574298858642578 8.785984039306641 7.406855583190918 C 8.954632759094238 7.239412307739258 9.049378395080566 7.01231050491333 9.049378395080566 6.775509834289551 L 9.049378395080566 5.454081535339355 L 10.36747455596924 5.454081535339355 C 10.60597991943359 5.454081535339355 10.83471584320068 5.360013008117676 11.00336456298828 5.192569732666016 C 11.17201328277588 5.025126457214355 11.26675987243652 4.798024654388428 11.26675987243652 4.561224460601807 C 11.26675987243652 4.324423789978027 11.17201328277588 4.097322463989258 11.00336456298828 3.929879188537598 C 10.83471584320068 3.762436151504517 10.60597991943359 3.668367385864258 10.36747455596924 3.668367385864258 L 9.041670799255371 3.668367385864258 L 9.041670799255371 2.357142686843872 C 9.041670799255371 2.120342254638672 8.946925163269043 1.893240690231323 8.778276443481445 1.725797533988953 C 8.609627723693848 1.558354258537292 8.380890846252441 1.464285612106323 8.142385482788086 1.464285612106323 C 7.90388011932373 1.464285612106323 7.675143241882324 1.558354258537292 7.506494522094727 1.725797533988953 C 7.337845802307129 1.893240690231323 7.243100166320801 2.120342254638672 7.243100166320801 2.357142686843872 L 7.248238563537598 2.357142686843872 L 7.248238563537598 3.673469305038452 Z">
					</path>
				</svg>
				<svg class="Icon_plus_1_website_3" viewBox="15.91 0 5.365 5.327">
					<path id="Icon_plus_1_website_3" d="M 18.04702949523926 0.2241529673337936 C 17.90247344970703 0.3676756918430328 17.82126426696777 0.5623342990875244 17.82126426696777 0.7653061151504517 L 17.82126426696777 1.897959113121033 L 16.68045616149902 1.897959113121033 C 16.47602272033691 1.897959113121033 16.27996444702148 1.978589415550232 16.13540840148926 2.122112274169922 C 15.99085140228271 2.265635013580322 15.90964031219482 2.460293292999268 15.90964031219482 2.663265228271484 C 15.90964031219482 2.866236925125122 15.99085140228271 3.060895681381226 16.13540840148926 3.204418420791626 C 16.27996444702148 3.347941160202026 16.47602272033691 3.428571224212646 16.68045616149902 3.428571224212646 L 17.82126426696777 3.428571224212646 L 17.82126426696777 4.561224460601807 C 17.82126426696777 4.764195919036865 17.90247344970703 4.958854675292969 18.04702949523926 5.102377414703369 C 18.19158554077148 5.24590015411377 18.38764572143555 5.326530456542969 18.59207916259766 5.326530456542969 C 18.79651260375977 5.326530456542969 18.99257278442383 5.24590015411377 19.13712882995605 5.102377414703369 C 19.28168487548828 4.958854675292969 19.36289596557617 4.764195919036865 19.36289596557617 4.561224460601807 L 19.36289596557617 3.428571224212646 L 20.50370407104492 3.428571224212646 C 20.60492897033691 3.428571224212646 20.70516204833984 3.408776044845581 20.79868125915527 3.370316028594971 C 20.8922004699707 3.331855773925781 20.97717666625977 3.27548360824585 21.04875373840332 3.204418420791626 C 21.12033081054688 3.133353233337402 21.1771068572998 3.048986434936523 21.21584320068359 2.956135272979736 C 21.25458145141602 2.86328387260437 21.2745189666748 2.763766527175903 21.2745189666748 2.663265228271484 C 21.2745189666748 2.562763690948486 21.25458145141602 2.46324634552002 21.21584320068359 2.370395183563232 C 21.1771068572998 2.277544021606445 21.12033081054688 2.193177461624146 21.04875373840332 2.122112274169922 C 20.97717666625977 2.051046848297119 20.8922004699707 1.994674921035767 20.79868125915527 1.956214666366577 C 20.70516204833984 1.917754530906677 20.60492897033691 1.897959113121033 20.50370407104492 1.897959113121033 L 19.36289596557617 1.897959113121033 L 19.36289596557617 0.7653061151504517 C 19.36289596557617 0.5623342990875244 19.28168487548828 0.3676756918430328 19.13712882995605 0.2241529673337936 C 18.99257278442383 0.08063022792339325 18.79651260375977 1.132880626568617e-16 18.59207916259766 0 L 18.59207916259766 0 C 18.38764572143555 1.699320939852926e-16 18.19158554077148 0.08063022792339325 18.04702949523926 0.2241529673337936 Z">
					</path>
				</svg>
			</div>
		</div>
		<div id="Card_01_website_3">
			<div id="Scroll_Group_10">
				<div id="intro_website_3">
					<span>{props.data.vision}</span>
				</div>
			</div>
			<div id="Vision_website_3">
				<span>Vision</span>
			</div>
			<div id="Icon_grp_website_3">
				<svg class="Fill_11_website_3">
					<rect id="Fill_11_website_3" rx="20" ry="20" x="0" y="0" width="90" height="90">
					</rect>
				</svg>
				<svg class="Icon_2_website_3" viewBox="17.672 17.672 7.328 7.328">
					<path id="Icon_2_website_3" d="M 25 25 L 17.67241287231445 17.67241287231445">
					</path>
				</svg>
				<svg class="Icon_1_website_3" viewBox="0 0 20.69 20.69">
					<path id="Icon_1_website_3" d="M 20.68965530395508 10.34482765197754 C 20.68965530395508 4.631536960601807 16.0581169128418 0 10.34482765197754 0 C 4.631536960601807 0 0 4.631536960601807 0 10.34482765197754 C 0 16.0581169128418 4.631536960601807 20.68965530395508 10.34482765197754 20.68965530395508 C 16.0581169128418 20.68965530395508 20.68965530395508 16.0581169128418 20.68965530395508 10.34482765197754 Z">
					</path>
				</svg>
			</div>
		</div>
		<div id="what_we_stand_for_website_3">
			<span>What We Stand For</span>
		</div>
		<div id="deisgn_grp_we_stand_left">
			<svg class="centre_linewebsite_3" viewBox="0 0 191.5 3">
				<path id="centre_linewebsite_3" d="M 0 0 L 191.5 0">
				</path>
			</svg>
			<svg class="right_we_stand_circle">
				<ellipse id="right_we_stand_circle" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
				</ellipse>
			</svg>
			<svg class="left_we_stand_circle">
				<ellipse id="left_we_stand_circle" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
				</ellipse>
			</svg>
		</div>
		<div id="what_we_shand_for_arrow_mid_le">
			<svg class="centre_line_website_3" viewBox="0 0 191.5 3">
				<path id="centre_line_website_3" d="M 0 0 L 191.5 0">
				</path>
			</svg>
			<svg class="circle_left_website_3">
				<ellipse id="circle_left_website_3" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
				</ellipse>
			</svg>
			<svg class="circle_right_website_3">
				<ellipse id="circle_right_website_3" rx="5.5" ry="5.5" cx="5.5" cy="5.5">
				</ellipse>
			</svg>
		</div>
	</div>


	<div id="hidding_part_2_web_3_pc_info">
		<div id="Email_input_field">
			<svg class="bg_website_3">
				<rect id="bg_website_3" rx="0" ry="0" x="0" y="0" width="686" height="124">
				</rect>
			</svg>
			<div id="text_website_3">
				<span>Type your Email Address</span>
			</div>
		</div>
		<div id="Button_Send_website_3">
			<svg class="bg_website_3_orange">
				<rect id="bg_website_3_orange" rx="0" ry="0" x="0" y="0" width="167" height="72">
				</rect>
			</svg>
			<div id="subscribe_lbl__website_3">
				<span>Subscribe</span>
			</div>
		</div>
		<div id="to_join_website_3">
			<span>To join the worldwide community</span>
		</div>
		<div id="sub_title_lbl_website_3">
			<span>Subscribe to Our Newsletter</span>
		</div>
	</div>


	<div id="hiding_part_1_web_3_pc_comment">
		<div id="Card_01_testi_website_3">
			<svg class="Base_website_3">
				<rect id="Base_website_3" rx="10" ry="10" x="0" y="0" width="380" height="367">
				</rect>
			</svg>
			<div id="Los_Angeles_CA_website_3">
				<span>Los Angeles, CA</span>
			</div>
			<div id="Jane_Cooper_website_3">
				<span>Jane Cooper</span>
			</div>
			<img id="Image_website_3" src="./Themes/OceanicBliss/Image_website_3.png" srcset="./Themes/OceanicBliss/Image_website_3.png 1x" />
				
			<div id="Moderate_children_website_3">
				<span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at risus euismod, bibendum quam sed, pellentesque magna.</span>
			</div>
			<div id="Review_website_3">
				<svg class="Star_1_website_3" viewBox="0.988 0.513 15.479 13.907">
					<path id="Star_1_website_3" d="M 8.491058349609375 0.6815586686134338 C 8.568754196166992 0.4573823213577271 8.885793685913086 0.4573823213577271 8.963489532470703 0.6815586686134338 L 10.62839794158936 5.485365390777588 C 10.66327857971191 5.586008071899414 10.75809669494629 5.653497695922852 10.8646125793457 5.653497695922852 L 16.21627998352051 5.653497695922852 C 16.46234893798828 5.653497695922852 16.56039237976074 5.971595764160156 16.35701751708984 6.110120296478271 L 12.0557746887207 9.039841651916504 C 11.96245002746582 9.103408813476562 11.92331981658936 9.221641540527344 11.96029663085938 9.328332901000977 L 13.60966968536377 14.08731365203857 C 13.6885232925415 14.31483173370361 13.43173217773438 14.51136016845703 13.23271656036377 14.37580394744873 L 8.868011474609375 11.40285682678223 C 8.783099174499512 11.34502029418945 8.671448707580566 11.34502029418945 8.586536407470703 11.40285682678223 L 4.221831321716309 14.37580394744873 C 4.022815704345703 14.51136016845703 3.766024827957153 14.31483173370361 3.844878435134888 14.08731365203857 L 5.494250774383545 9.328332901000977 C 5.531227588653564 9.221641540527344 5.492097854614258 9.103408813476562 5.398773193359375 9.039841651916504 L 1.097529530525208 6.110120296478271 C 0.8941559791564941 5.971595764160156 0.9921983480453491 5.653497695922852 1.238267064094543 5.653497695922852 L 6.589934825897217 5.653497695922852 C 6.696450710296631 5.653497695922852 6.791269302368164 5.586008071899414 6.826150417327881 5.485365390777588 L 8.491058349609375 0.6815586686134338 Z">
					</path>
				</svg>
				<svg class="Star_2_website_3" viewBox="0.988 0.513 15.479 13.907">
					<path id="Star_2_website_3" d="M 8.491058349609375 0.6815586686134338 C 8.568754196166992 0.4573823213577271 8.885793685913086 0.4573823213577271 8.963489532470703 0.6815586686134338 L 10.62839794158936 5.485365390777588 C 10.66327857971191 5.586008071899414 10.75809669494629 5.653497695922852 10.8646125793457 5.653497695922852 L 16.21627998352051 5.653497695922852 C 16.46234893798828 5.653497695922852 16.56039237976074 5.971595764160156 16.35701751708984 6.110120296478271 L 12.0557746887207 9.039841651916504 C 11.96245002746582 9.103408813476562 11.92331981658936 9.221641540527344 11.96029663085938 9.328332901000977 L 13.60966968536377 14.08731365203857 C 13.6885232925415 14.31483173370361 13.43173217773438 14.51136016845703 13.23271656036377 14.37580394744873 L 8.868011474609375 11.40285682678223 C 8.783099174499512 11.34502029418945 8.671448707580566 11.34502029418945 8.586536407470703 11.40285682678223 L 4.221831321716309 14.37580394744873 C 4.022815704345703 14.51136016845703 3.766024827957153 14.31483173370361 3.844878435134888 14.08731365203857 L 5.494250774383545 9.328332901000977 C 5.531227588653564 9.221641540527344 5.492097854614258 9.103408813476562 5.398773193359375 9.039841651916504 L 1.097529530525208 6.110120296478271 C 0.8941559791564941 5.971595764160156 0.9921983480453491 5.653497695922852 1.238267064094543 5.653497695922852 L 6.589934825897217 5.653497695922852 C 6.696450710296631 5.653497695922852 6.791269302368164 5.586008071899414 6.826150417327881 5.485365390777588 L 8.491058349609375 0.6815586686134338 Z">
					</path>
				</svg>
				<svg class="Star_3_website_3" viewBox="0.988 0.513 15.479 13.907">
					<path id="Star_3_website_3" d="M 8.491058349609375 0.6815586686134338 C 8.568754196166992 0.4573823213577271 8.885793685913086 0.4573823213577271 8.963489532470703 0.6815586686134338 L 10.62839794158936 5.485365390777588 C 10.66327857971191 5.586008071899414 10.75809669494629 5.653497695922852 10.8646125793457 5.653497695922852 L 16.21627998352051 5.653497695922852 C 16.46234893798828 5.653497695922852 16.56039237976074 5.971595764160156 16.35701751708984 6.110120296478271 L 12.0557746887207 9.039841651916504 C 11.96245002746582 9.103408813476562 11.92331981658936 9.221641540527344 11.96029663085938 9.328332901000977 L 13.60966968536377 14.08731365203857 C 13.6885232925415 14.31483173370361 13.43173217773438 14.51136016845703 13.23271656036377 14.37580394744873 L 8.868011474609375 11.40285682678223 C 8.783099174499512 11.34502029418945 8.671448707580566 11.34502029418945 8.586536407470703 11.40285682678223 L 4.221831321716309 14.37580394744873 C 4.022815704345703 14.51136016845703 3.766024827957153 14.31483173370361 3.844878435134888 14.08731365203857 L 5.494250774383545 9.328332901000977 C 5.531227588653564 9.221641540527344 5.492097854614258 9.103408813476562 5.398773193359375 9.039841651916504 L 1.097529530525208 6.110120296478271 C 0.8941559791564941 5.971595764160156 0.9921983480453491 5.653497695922852 1.238267064094543 5.653497695922852 L 6.589934825897217 5.653497695922852 C 6.696450710296631 5.653497695922852 6.791269302368164 5.586008071899414 6.826150417327881 5.485365390777588 L 8.491058349609375 0.6815586686134338 Z">
					</path>
				</svg>
				<svg class="Star_4_website_3" viewBox="0.988 0.513 15.479 13.907">
					<path id="Star_4_website_3" d="M 8.491058349609375 0.6815586686134338 C 8.568754196166992 0.4573823213577271 8.885793685913086 0.4573823213577271 8.963489532470703 0.6815586686134338 L 10.62839794158936 5.485365390777588 C 10.66327857971191 5.586008071899414 10.75809669494629 5.653497695922852 10.8646125793457 5.653497695922852 L 16.21627998352051 5.653497695922852 C 16.46234893798828 5.653497695922852 16.56039237976074 5.971595764160156 16.35701751708984 6.110120296478271 L 12.0557746887207 9.039841651916504 C 11.96245002746582 9.103408813476562 11.92331981658936 9.221641540527344 11.96029663085938 9.328332901000977 L 13.60966968536377 14.08731365203857 C 13.6885232925415 14.31483173370361 13.43173217773438 14.51136016845703 13.23271656036377 14.37580394744873 L 8.868011474609375 11.40285682678223 C 8.783099174499512 11.34502029418945 8.671448707580566 11.34502029418945 8.586536407470703 11.40285682678223 L 4.221831321716309 14.37580394744873 C 4.022815704345703 14.51136016845703 3.766024827957153 14.31483173370361 3.844878435134888 14.08731365203857 L 5.494250774383545 9.328332901000977 C 5.531227588653564 9.221641540527344 5.492097854614258 9.103408813476562 5.398773193359375 9.039841651916504 L 1.097529530525208 6.110120296478271 C 0.8941559791564941 5.971595764160156 0.9921983480453491 5.653497695922852 1.238267064094543 5.653497695922852 L 6.589934825897217 5.653497695922852 C 6.696450710296631 5.653497695922852 6.791269302368164 5.586008071899414 6.826150417327881 5.485365390777588 L 8.491058349609375 0.6815586686134338 Z">
					</path>
				</svg>
				<svg class="Star_5_website_3" viewBox="0.988 0.513 15.479 13.907">
					<path id="Star_5_website_3" d="M 8.491058349609375 0.6815586686134338 C 8.568754196166992 0.4573823213577271 8.885793685913086 0.4573823213577271 8.963489532470703 0.6815586686134338 L 10.62839794158936 5.485365390777588 C 10.66327857971191 5.586008071899414 10.75809669494629 5.653497695922852 10.8646125793457 5.653497695922852 L 16.21627998352051 5.653497695922852 C 16.46234893798828 5.653497695922852 16.56039237976074 5.971595764160156 16.35701751708984 6.110120296478271 L 12.0557746887207 9.039841651916504 C 11.96245002746582 9.103408813476562 11.92331981658936 9.221641540527344 11.96029663085938 9.328332901000977 L 13.60966968536377 14.08731365203857 C 13.6885232925415 14.31483173370361 13.43173217773438 14.51136016845703 13.23271656036377 14.37580394744873 L 8.868011474609375 11.40285682678223 C 8.783099174499512 11.34502029418945 8.671448707580566 11.34502029418945 8.586536407470703 11.40285682678223 L 4.221831321716309 14.37580394744873 C 4.022815704345703 14.51136016845703 3.766024827957153 14.31483173370361 3.844878435134888 14.08731365203857 L 5.494250774383545 9.328332901000977 C 5.531227588653564 9.221641540527344 5.492097854614258 9.103408813476562 5.398773193359375 9.039841651916504 L 1.097529530525208 6.110120296478271 C 0.8941559791564941 5.971595764160156 0.9921983480453491 5.653497695922852 1.238267064094543 5.653497695922852 L 6.589934825897217 5.653497695922852 C 6.696450710296631 5.653497695922852 6.791269302368164 5.586008071899414 6.826150417327881 5.485365390777588 L 8.491058349609375 0.6815586686134338 Z">
					</path>
				</svg>
			</div>
		</div>
		<div id="Loved_by_businesses_and_indivi">
			<span>Loved by businesses, and individuals across the globe.</span>
		</div>
	</div>

	
	<div id="Scroll_upcoming_event_web_3_pc">
	 {props.eventsData && props.eventsData.map((eve)=>(
		<div id="Upcoming_evnt_grp_down_3_pc">
			<svg class="bgof_card_eventwebsite_3_pc">
				<rect id="bgof_card_eventwebsite_3_pc" rx="0" ry="0" x="0" y="0" width="1170" height="526">
				</rect>
			</svg>
			<div id="Button_website_3_pc">
				<svg class="Fbdr_website_3">
					<rect id="Fbdr_website_3" rx="5" ry="5" x="0" y="0" width="412" height="53">
					</rect>
				</svg>
				<div id="enroll_now_website_3">
					<span>Enroll Now</span>
				</div>
			</div>
			<div id="organizer_grp_website_3_pc">
				<div id="n__Room_website_3">
					<span>{eve.organiserName}</span>
				</div>
				<div id="organizer_website_3">
					<span>Organizer</span>
				</div>
			</div>
			<div id="when_to_wen_date_grp_3_pc">
				<div id="date_website_3_pc">
					<span>{eve.startsOn.slice(0,10)}          {eve.startsOn.slice(11,16)} IST  </span>
				</div>
			</div>
			<div id="avaliable_website_3_pc">
				<div id="n_000_website_3_pc">
					<span>1000</span>
				</div>
				<div id="avaliablewebsite_3_pc">
					<span>Avaliable</span>
				</div>
			</div>
			<div id="seats_grp_website_3_pc">
				<div id="n_200_m2_website_3">
					<span>{eve.seats}</span>
				</div>
				<div id="seats_website_3">
					<span>Seats</span>
				</div>
			</div>
			<div id="cost_grp_website_3_pc">
				<div id="Confidential_website_3">
					<span>₹ {eve.cost}</span>
				</div>
				<div id="cost_website_3">
					<span>Cost</span>
				</div>
			</div>
			<div id="Scroll_event_desc_3">
				<div id="event_info_website_3_pc">
					<span>{eve.description}</span>
				</div>
			</div>
			<div id="event__name_website_3_pc">
				<span>{eve.title}</span>
			</div>
			<img id="Image_1_website_3_pc" src={eve.eventImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(eve.eventImageUrl.split('/')[5]):"./Themes/OceanicBliss/Image_1_website_3_pc.png"} />
				
		</div>
		))}
	</div>



	<div id="Featured_Listing_of_the_Week">
		<span>Upcoming Events</span>
	</div>
	<div id="offering_area_web_3">
		<div id="Scroll_Offering_web_3">
        {props.offeringsData.map((rec,idx)=>(  
			<div id="name_anf_off_img_web_3">
				<img id="Image_03_website_3" src={rec.defaultOfferingsImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(rec.defaultOfferingsImageUrl.split('/')[5]):"./Themes/OceanicBliss/Image_03_website_3.png" }/>
					
				
				<div id="offering_Menu_website_3">
					<div id="Menu_website_3">
						<div id="Residential_Property_website_3">
							<span>{rec.offeringTitle}</span>
						</div>
					</div>
				</div>
            </div>		
            ))}
		</div>
		<div id="offering_mid_grp_website_3">
			<div id="slogal_website_3">
				<span>Check out our Latest Offerings !!!</span>
			</div>
			<div id="offerings_lbl_website_3">
				<span>Offerings</span>
			</div>
		</div>
	</div>
	<img id="img_website_website_3" src="./Themes/OceanicBliss/img_website_website_3.png" srcset="./Themes/OceanicBliss/img_website_website_3.png 1x" />
		
	<div id="footer_grp_website_3">
		<svg class="Line_2_website_3" viewBox="0 0 1173 1">
			<path id="Line_2_website_3" d="M 0 0 L 1173 0">
			</path>
		</svg>
		<a href="https://operate.live" target="_blank">
		<div id="n_Copyright_Operate_Live_websi_ob_pc">
			<span>© Copyright Operate Live (OPC) Private Limited. All Rights Reserved</span>
		</div>
		</a>
	</div>
    <a href="#Heading_website_3">
	<div id="home_website_3">
		<div id="Home_website_3_et">
			<span>Home</span>
		</div>
		<img id="home-icon-silhouette_website_3" src="./Themes/OceanicBliss/home-icon-silhouette_website_3.png" srcset="./Themes/OceanicBliss/home-icon-silhouette_website_3.png 1x" />
			
	</div></a>
    <a href="#offerings_lbl_website_3">
	<div id="offering_website_3">
		<div id="Offerings_website_3">
			<span>Offerings</span>
		</div>
		<img id="discount_website_3" src="./Themes/OceanicBliss/discount_website_3.png" srcset="./Themes/OceanicBliss/discount_website_3.png 1x" />		
	</div>
    </a>

      <a href="#Featured_Listing_of_the_Week">
	<div id="event_grp_website_3">
		<div id="Events_website_3">
			<span>Events</span>
		</div>
		<img id="election-event-on-a-calendar-w" src="./Themes/OceanicBliss/election-event-on-a-calendar-w.png" srcset="./Themes/OceanicBliss/election-event-on-a-calendar-w.png 1x" />
			
	</div></a>
	<div id="contact_grp_website_3">
		<div id="Contact_lbl_website_3">
			<span>Contact</span>
		</div>
		<img id="contact_img_website_3" src="./Themes/OceanicBliss/contact_img_website_3.png" srcset="./Themes/OceanicBliss/contact_img_website_3.png 1x" />
			
	</div>
	<div id="Partners_grp_web_3">
		<div id="text_our_partners_website_3">
			<span>Our Success Partners</span>
		</div>
		<div id="Scroll_Group_13">
        {props.partnersData && props.partnersData.map(partner=>
        <div onClick={()=>window.location.href="https://"+partner.nickName+".operate.live"}>
			<div id="partner_lbls_grp3">
				<div id="google_lbl_partner_website_23">
					<span>{partner.businessName && partner.businessName.length>0?partner.businessName:partner.name}</span>
				</div>
				
				<img id="google_1_website_23" src={partner.imageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(partner.imageUrl.split('/')[5]):"./Themes/office.png"}/>

                </div>	
			</div>
            )}
		</div>
	</div>


	<div id="all_info_grp_card_below_pc_3_w">
		<img id="bg_of_info_web_3_pc" src="./Themes/OceanicBliss/bg_of_info_web_3_pc.png" srcset="./Themes/OceanicBliss/bg_of_info_web_3_pc.png 1x" />
			
		<div id="Connect_Unlock_3_pc">
			<span>"Connect. Unlock. Unlimited <br/>possibilities await you!"</span>
		</div>
		<div id="n_234567890e_number_website_3_">
			<span>{props.data.businessPhone}</span>
		</div>
		<div id="affanghanioperatelive_website3_pc">
			<span>{props.data.businessEmail}</span>
		</div>
		<div id="address_website_3_pc">
			<span>{props.data.businessAddress}</span>
		</div>
		<img id="location_img_website_3_pc" src="./Themes/OceanicBliss/location_img_website_3_pc.png" srcset="./Themes/OceanicBliss/location_img_website_3_pc.png 1x" />
			
		<img id="email_address_website_3_pc" src="./Themes/OceanicBliss/email_address_website_3_pc.png" srcset="./Themes/OceanicBliss/email_address_website_3_pc.png 1x" />
			
		<img id="phone_number_website_3_pc" src="./Themes/OceanicBliss/phone_number_website_3_pc.png" srcset="./Themes/OceanicBliss/phone_number_website_3_pc.png 1x" />
			
		<img id="quote_left_webstie_3_pc" src="./Themes/OceanicBliss/quote_left_webstie_3_pc.png" srcset="./Themes/OceanicBliss/quote_left_webstie_3_pc.png 1x" />
			
		<img id="quote_right_website_3_pc" src="./Themes/OceanicBliss/quote_right_website_3_pc.png" srcset="./Themes/OceanicBliss/quote_right_website_3_pc.png 1x" />
			
	</div>
</div>
    </div>
  )
}

export default OceanicBliss
